import { useState } from 'react';
import type { Collection } from '@/services/app.service';
import { createContext, useContext, useMemo } from 'react';

type ContextTypes = {
  collections: Collection[];
  setCollections: React.Dispatch<React.SetStateAction<Collection[]>>;
};

const FaqDataContext = createContext<ContextTypes | undefined>(undefined);

export const FaqDataProvider = ({ children }: React.PropsWithChildren) => {
  const [collections, setCollections] = useState<Collection[]>([]);

  const value = useMemo(
    () => ({
      collections,
      setCollections,
    }),
    [collections],
  );

  return <FaqDataContext.Provider value={value}>{children}</FaqDataContext.Provider>;
};

export const useFaqData = () => {
  const context = useContext(FaqDataContext);
  if (!context) {
    throw new Error('useFaqData must be used in a FaqDataProvider');
  }
  return context;
};
